import { Component, OnInit, AfterViewInit } from '@angular/core';
import { GRADIENT_ICONS } from 'src/app/constants/imagePath';
declare var AOS: any;
@Component({ selector: 'app-sol-rewards', templateUrl: './rewards.component.html', styleUrls: ['./rewards.component.scss'], standalone: false })
export class ConsumerRewardsComponent implements OnInit, AfterViewInit {
  activeSection = 'overview';
  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'features', label: 'Features', icon: 'bx-coin-stack' },
    { id: 'howto', label: 'How to Earn', icon: 'bx-trending-up' },
  ];
  features = [
    { icon: 'bx-coin-stack', iconImage: GRADIENT_ICONS.MILES, title: 'Varroc Miles', desc: 'Earn miles on every km driven — convert them to fuel cashback, service discounts, and partner offerings.' },
    { icon: 'bx-user-check', title: 'Safe Driver Bonus', desc: 'Extra points for good driving scores — speed compliance, smooth braking, and safe routing.' },
    { icon: 'bx-store', title: 'Partner Rewards', desc: 'Redeem at 500+ partners including fuel stations, quick-service restaurants, and automotive services.' },
    { icon: 'bx-gift', title: 'Milestone Rewards', desc: 'Unlock special rewards at distance milestones — 1,000 km, 10,000 km, and lifetime achievements.' },
    { icon: 'bx-group', title: 'Referral Bonus', desc: 'Earn bonus miles for every friend you refer to the Varroc Connect platform.' },
    { icon: 'bx-credit-card', title: 'V-Store Redemption', desc: 'Spend miles directly in the V-Store for vehicle accessories, gadgets, and digital services.' },
  ];
  earnSteps = ['Connect your vehicle via OBD or TCU', 'Drive safely and earn miles per km', 'Bonus miles for high safety scores', 'Redeem at partners or in V-Store'];
  ngOnInit() {}
  ngAfterViewInit() { try { AOS.refresh(); } catch (e) {} }
  scrollTo(id: string) {
    this.activeSection = id;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
